import { useQuery } from "react-query";
import API from "../../axios/API";
import { QUERY_KEYS } from "../keys";
import { GET_ENDPOINTS } from "@/axios/API/endpoints";

const getTeamRoles = async (teamId) => {
  const { data } = await API.get(`${GET_ENDPOINTS.TEAM_ROLES}${teamId}`);
  return data;
};

const useTeamRoles = (teamId) =>
  useQuery([QUERY_KEYS.TEAM_ROLES, teamId], () => getTeamRoles(teamId));

export default useTeamRoles;
